module.exports = __webpack_public_path__ + "media/images/banner_app_en-0b35937b5e414c6612d64ec98c6c82fe.png";